import { originalCreateInstance } from '../../externals/axios';
import { VERSION } from '../../version';
import { assign } from '../utils';
export default (function (config) {
    if (!config.headers || !config.headers['Content-Type']) {
        config.headers = assign({}, config.headers || {}, {
            'Content-Type': 'application/json'
        });
    }
    config.errorConfig = config.errorConfig || {};
    config.logConfig = config.logConfig || {};
    config.debounceConfig = config.debounceConfig || {};
    var axiosInstance = originalCreateInstance(config);
    var logConfig = (config || {}).logConfig;
    var logger = (logConfig || {}).logger;
    if (logger && logger.updateCommonPackage) {
        try {
            logger.updateCommonPackage({
                h5_extra_attr: {
                    esRequestVersion: VERSION
                },
            });
        }
        catch (e) {
            if (logger.collect) {
                logger.collect('CUSTOM', 'ESHOP_REQUEST_UPDATE_VERSION_ERROR', {
                    message: (e && e.message) || "\u66F4\u65B0\u9519\u8BEF\u7248\u672C" + VERSION,
                    esRequestVersion: VERSION
                });
            }
        }
    }
    return axiosInstance;
});
//# sourceMappingURL=createAxiosInstance.js.map